import {createBrowserHistory} from "history";
import {ENV} from "./configuration";

// Singleton history instance
export let history = createBrowserHistory({
    basename: ENV.ROUTER_BASE_NAME
});

export function getHistory() {
    return history;
}

// Function to update history when config changes
export function updateHistory() {
    history = createBrowserHistory({
        basename: ENV.ROUTER_BASE_NAME
    });
}
